import { Component, Input } from '@angular/core';
import { find } from 'lodash';

@Component({
  selector: 'app-unruly-banner',
  templateUrl: './unruly-banner.component.html',
  styleUrls: ['./unruly-banner.component.less']
})
export class UnrulyBannerComponent {

  splashMarkups: string[] = [];
  isDontShowMsgAgainChb = false;

  splashMarkupsConfig: {key: string; localStorageKey: string; markup: string}[] = [
    {
      key: 'aug-01-2024-partner',
      localStorageKey: 'notif_15',
      markup: `
        <h2>
            Welcome back to Nexxen Curated Marketplace!
        </h2>
        <p>
           As a beta partner, you’ll be the first to use your audience data in Nexxen curated deals and access new platform
           features as we iterate.
        </p>
        <h3>
            *New* KPI Filters for Deals
        </h3>
        <p>
          You can now define KPIs-Click Through Rate (CTR), Video Completion Rate (VCR),
          and/or Viewability Score-when configuring your Curated Marketplace deals.
          The available KPI options will vary depending on the Impression Type (Video, Banner, Native, Audio).
        </p>
        <p>
          Previous UI releases include the ability to add content segments (genre, language, rating) and select alternative currencies
          for floor price. More capabilities will be added on a rolling basis.
        </p>
        <p>
            For additional questions, please reach out to your account manager.
        </p>
      `
    },
  ];
  private _keysToShow: string[] = [];
  get keysToShow() {
    return this._keysToShow;
  }
  @Input()
  set keysToShow(keysToShow) {
    this._keysToShow = keysToShow;
    this.prepareSplashMarkups();
  }


  prepareSplashMarkups() {
    this.splashMarkups = [];
    this.splashMarkupsConfig.forEach(config => {
      if (this.keysToShow.includes(config.key) && JSON.parse(localStorage.getItem(config.localStorageKey)) !== true) {
        this.splashMarkups.push(config.markup);
      }
    });
  }

  onCloseModal() {
    this.splashMarkups = [];
    if (this.isDontShowMsgAgainChb) {
      this.keysToShow.forEach(key => {
        const config = this.getSplashConfig(key);
        if (config) {
          localStorage.setItem(config.localStorageKey, JSON.stringify(true));
        }
      });
    }
  }

  getSplashConfig(key: string) {
    return find(this.splashMarkupsConfig, ['key', key]);
  }

  isModalVisible(): boolean {
    return this.splashMarkups.length > 0;
  }

}
